import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConfig } from '../../apiConfig';
import { HelpAndSupport } from '../../data/admin/help-and-support-data';
import { BaseResponse } from '../../models';
import { FaqsRequestDTO, HelpAndSupportRequestDTO } from '../../models/admin/help-and-support';
import { UtilityService } from '../shared-services/utility.service';

@Injectable({
  providedIn: 'root'
})
export class HelpAndSupportService extends HelpAndSupport {


  constructor(private utilityService: UtilityService) {
    super();
  }

  saveHelpAndSupport(data?: HelpAndSupportRequestDTO, id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>> {
    return this.utilityService.postPut<HelpAndSupportRequestDTO[]>(
      ApiConfig.admin.saveNewHelpAndSupportInfo,
      data,
      id
    );
  }
  deleteHelpAndSupport(id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>> {
    return this.utilityService.postPut<any>(
      ApiConfig.admin.deleteNewHelpAndSupportInfo,
      null,
      id
    );
  }
  getFaqs(data?: FaqsRequestDTO, id?: any, categoryName?: string): Observable<BaseResponse<FaqsRequestDTO[]>> {
    return this.utilityService.postPut<FaqsRequestDTO[]>(
      ApiConfig.admin.getfaqs,
      data,
      id
    );
  }
  getCategory(id?: any, categoryName?: string): Observable<BaseResponse<any[]>> {
    return this.utilityService.postPut<any[]>(
      ApiConfig.admin.getfaqsCategory,
      null,
      id
    );
  }
  editCategory(data?: any): Observable<BaseResponse<any>> {
    return this.utilityService.postPut<any>(
      ApiConfig.admin.editfaqsCategory,
      data
    );
  }
  saveFaqs(data?: FaqsRequestDTO, id?: any): Observable<BaseResponse<any>> {
    return this.utilityService.postPut<any>(
      ApiConfig.admin.savefaqs,
      data,
      id
    );
  }
  deleteFaqs(id: any): Observable<BaseResponse<any>> {
    return this.utilityService.postPut<any>(
      ApiConfig.admin.deletefaqs,
      null,
      id
    );
  }
  deletefaqscategory(category: any): Observable<BaseResponse<any>> {
    return this.utilityService.postPut<any>(
      ApiConfig.admin.deletefaqscategory,
      null,
      null,
      "post",
      { category: category },
    );
  }

  getHelpAndSupportInfo(id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>> {
    return this.utilityService.postPut<HelpAndSupportRequestDTO[]>(
      ApiConfig.admin.getHelpAndSupportInfo,
      null,
      id
    );
  }

  getContactUs(id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>> {
    return this.utilityService.postPut<HelpAndSupportRequestDTO[]>(
      ApiConfig.admin.getContactUs,
      null,
      id
    );
  }
  updateContactUs(data?: HelpAndSupportRequestDTO, id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>> {
    return this.utilityService.postPut<HelpAndSupportRequestDTO[]>(
      ApiConfig.admin.updateContactUs,
      data,
      id
    );
  }
  getCallMeBack(id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>> {
    return this.utilityService.postPut<HelpAndSupportRequestDTO[]>(
      ApiConfig.admin.getCallMeBack,
      null,
      id
    );
  }
  updateCallMeBack(data?: HelpAndSupportRequestDTO, id?: any): Observable<BaseResponse<HelpAndSupportRequestDTO[]>> {
    return this.utilityService.postPut<HelpAndSupportRequestDTO[]>(
      ApiConfig.admin.updateCallMeBack,
      data,
      id
    );
  }


}
